import{GETSPINTOSSRAPPORT} from "../ActionTypes/RapportSpintoss"
import { ADD_RAPPORT_SPINTOSS_SUCCESS, ADD_RAPPORT_SPINTOSS_FAILURE } from "../ActionTypes/RapportSpintoss"

import axios from "axios"



export const getrapportspintoss = (params) => async (dispatch) => {
  try {
    const res = await axios.get('/api/RapportsSpintoss/GetRapportsSpintoss', { params });
    dispatch({
      type: GETSPINTOSSRAPPORT,
      payload: res.data.RapportsSpintoss
    });
    return res.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

        export const AddRapportsSpintoss=(newRapportspintoss,navigate)=>async(dispatch)=>{
    
         try {
            
             await axios.post('/api/RapportsSpintoss/AddRapportsSpintoss',newRapportspintoss,{
              headers : {
                  Authorised : localStorage.getItem('token')
              }
          })
      
             dispatch(getrapportspintoss())
      
              alert("Votre rapport a été bien envoyé à l'administration");
              window.location.reload();
           
         } catch (error) {
             console.log(error)
         }
      }

      